import { render, staticRenderFns } from "./SetBranchProductList.vue?vue&type=template&id=5415dc11&scoped=true"
import script from "./SetBranchProductList.vue?vue&type=script&lang=js"
export * from "./SetBranchProductList.vue?vue&type=script&lang=js"
import style0 from "./SetBranchProductList.vue?vue&type=style&index=0&id=5415dc11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5415dc11",
  null
  
)

export default component.exports